'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classView = function classView() {
  return import('@/page/class');
};
var classList = function classList() {
  return import('@/page/class/class-list');
};
var classDetail = function classDetail() {
  return import('@/page/class/class-detail');
};
var classResourse = function classResourse() {
  return import('@/page/class/class-menu/resourse');
};
var classMaillist = function classMaillist() {
  return import('@/page/class/class-menu/maillist');
};
var classAssessment = function classAssessment() {
  return import('@/page/class/class-menu/assessment');
};
var classAlbum = function classAlbum() {
  return import('@/page/class/class-menu/album');
};
var classCertificate = function classCertificate() {
  return import('@/page/class/class-menu/certificate');
};
var certificateDetail = function certificateDetail() {
  return import('@/page/class/class-menu/certificate-detail');
};
var communicationDetail = function communicationDetail() {
  return import('@/page/class/class-detail/communication-detail');
};

exports.default = [{
  path: '/class',
  name: 'class',
  component: classView,
  children: [{
    path: 'class-list',
    name: 'class-list',
    component: classList
  }, {
    path: 'class-detail',
    name: 'class-detail',
    component: classDetail
  }, {
    path: 'class-assessment',
    name: 'class-assessment',
    component: classAssessment
  }, {
    path: 'class-resourse',
    name: 'class-resourse',
    component: classResourse
  }, {
    path: 'class-album',
    name: 'class-album',
    component: classAlbum
  }, {
    path: 'class-maillist',
    name: 'class-maillist',
    component: classMaillist
  }, {
    path: 'class-certificate',
    name: 'class-certificate',
    component: classCertificate
  }, {
    path: 'certificate-detail',
    name: 'certificate-detail',
    component: certificateDetail
  }, {
    path: 'communication-detail',
    name: 'communication-detail',
    component: communicationDetail
  }]
}];